import { QueryFilters } from './queryKeys';
import { InvalidateOptions } from '../../../queries/types';
import { queryClient as globalQueryClient } from '../../../../store/store';

export class AssetsQueryInvalidator {
	static invalidateAllAssetsAndFoldersFromProject = (
		projectID: number,
		{ queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			...QueryFilters.forAssetAndFolderLists( { projectID } ),
			refetchType: 'none'
		} );

		queryClient.invalidateQueries( {
			...QueryFilters.forItemsCount( { projectID } ),
			refetchType: 'active'
		} );
	}

	static invalidateProjectOverviews = (
		projectID: number,
		{ queryClient = globalQueryClient }: InvalidateOptions = {}
	) => {
		queryClient.invalidateQueries( {
			...QueryFilters.forProjectOverviews( { projectID } ),
			refetchType: 'active'
		} );
	}
}
